import orderTranslationsHelper from "../../../../languages/order-translations.helper";

const getContentMessageText = (cargoCompanyOrderId: number) => {
  const translations =
    orderTranslationsHelper.getEditTranslations().summary.cancelEdit
      .confirmationModal;

  return translations.contentMessageTemplateText.replace(
    "#{cargoCompanyOrderId}",
    String(cargoCompanyOrderId)
  );
};

const orderRouteEditCancelEditConfirmationHelper = {
  getContentMessageText,
};

export default orderRouteEditCancelEditConfirmationHelper;
